import { Table } from "@/features/Table";
import { type User, users_columns } from "./columns";
import { type FilterUsersSchema, FilterUsers } from "./filter";
import { useLocation } from "react-router-dom";

const client = "admin-quantilia";
const table_name = "users";

export const UsersTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<User, FilterUsersSchema>
      label="Users"
      client={client}
      table_name={table_name}
      columns={users_columns}
      filter={<FilterUsers />}
      disable_translations_request={true}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
